<template>
<div class="chapter">
<div class="inner_page">
<div class="adCardPage" id="adCardPage_01"><h2 class="adCardHead">Also by Brian McGrory</h2><p class="adCardText"><span><em class="italic"><span>The Incumbent</span></em></span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780743483629_adCardPage_01.vue?2e8baf8a